// API client para la consola de WhatsApp (App Review demo).
// Backend: apps/meta/routers/whatsapp_demo.py (Django), montado en
//   /api/v1/admin/meta/whatsapp-demo/*
// Envía y gestiona plantillas desde un número de PRUEBA de Meta ya conectado a
// la app Orión. Herramienta interna (gateada a superuser) para grabar los
// videos de Meta App Review — no es para clientes.

import { ensureFreshToken } from '@/lib/tokenRefresh';

const DJANGO_PROXY = '/django-api';
const BASE = '/api/v1/admin/meta/whatsapp-demo';

async function authHeaders(): Promise<Record<string, string>> {
  await ensureFreshToken();
  const token = localStorage.getItem('auth_token');
  const orgId = localStorage.getItem('org_id') || '';
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (orgId) headers['X-Org-Id'] = orgId;
  return headers;
}

export class WhatsAppConsoleError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = 'WhatsAppConsoleError';
    this.status = status;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = await authHeaders();
  const res = await fetch(`${DJANGO_PROXY}${BASE}${path}`, {
    ...init,
    headers: { ...headers, ...(init?.headers || {}) },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const detail = (body as { detail?: string }).detail || `HTTP ${res.status}`;
    throw new WhatsAppConsoleError(
      typeof detail === 'string' ? detail : JSON.stringify(detail),
      res.status,
    );
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export interface DemoConfig {
  waba_id: string;
  phone_number_id: string;
  org: string;
}

export interface WaTemplate {
  name: string;
  status?: string;
  category?: string;
  language?: string;
}

export interface SendPayload {
  to: string;
  body?: string;
  template_name?: string;
  language_code?: string;
}

export interface CreateTemplatePayload {
  name: string;
  body_text: string;
  category?: string;
  language_code?: string;
}

export const whatsAppConsoleApi = {
  getConfig: () => request<DemoConfig>('/config'),

  send: (payload: SendPayload) =>
    request<Record<string, unknown>>('/send', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  listTemplates: () => request<WaTemplate[]>('/templates'),

  createTemplate: (payload: CreateTemplatePayload) =>
    request<Record<string, unknown>>('/templates', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
